import React, { useState, useEffect } from "react"; 
import { useParams,useNavigate } from "react-router-dom";
import axios from "axios";

import "../components/EditMorePatient.css";

const EditMorePatient = () => {
  const { patient_course_id } = useParams();

  const [formData, setFormData] = useState({
    patient_course_id: "",
    diagnosis_id: "",
    diagnosis: "",
    diagnosisCode: "",
    symptom_names: [], // Initialize as empty array
    remark: "",
    remark4: "",
    regMode: "",
      course_date: "", // ✅ ADD

  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
const [patientId, setPatientId] = useState(null);

  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  const [symptoms, setSymptoms] = useState([]);
  const [loadingSymptoms, setLoadingSymptoms] = useState(false);
  const [medicines, setMedicines] = useState([]);
const [selectedMedicines, setSelectedMedicines] = useState([]);
const [loadingMedicines, setLoadingMedicines] = useState(false);

const navigate = useNavigate();

  // Fetch diagnosis options
  useEffect(() => {
    const fetchDiagnosisOptions = async () => {
      try {
        const res = await axios.get(
          "https://newerp.awasthivitality.com/api/diagnosis/options"
        );
        if (res.data.success) setDiagnosisOptions(res.data.data);
      } catch (err) {
        console.error("Failed to fetch diagnosis options", err);
      }
    };
    fetchDiagnosisOptions();
  }, []);

  // Fetch patient course
  useEffect(() => {
    if (!patient_course_id) {
      setError("No patient course ID provided in URL");
      setLoading(false);
      return;
    }

    const fetchPatientCourse = async () => {
      try {
        const res = await axios.get(
          `https://newerp.awasthivitality.com/api/patient-course/${patient_course_id}`
        );

        if (res.data.status && res.data.data) {
          const course = res.data.data;
          
          console.log('Fetched course data:', course);
  setPatientId(course.patient_id); // ✅ IMPORTANT

 // Inside fetchPatientCourse (useEffect)
const normalizeMedicines = (raw) => {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw.map(String).map(m => m.trim()).filter(Boolean);
  }

  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map(String).map(m => m.trim()).filter(Boolean);
      }
    } catch {
      return raw.split(",").map(m => m.trim()).filter(Boolean);
    }
  }

  return [];
};

const cleanMedicines = normalizeMedicines(course.medicine_names);
setSelectedMedicines(cleanMedicines);

setFormData({
  patient_course_id: course.patient_course_id || "",
  diagnosis_id: course.diagnosis_id || "",
  diagnosis: course.diagnosis_name || "",
  diagnosisCode: course.diagnosis_code || "",
  symptom_names: Array.isArray(course.symptom_names) ? course.symptom_names : [],
  medicine_names: course.medicine_names || "",
  remark: course.remark || "",
  remark4: course.remark4 || "",
  regMode: course.service_type || "",
    course_date: course.course_date || "", // ✅ ADD

});



          console.log('Set form data:', {
            diagnosis_id: course.diagnosis_id,
            symptom_names: course.symptom_names
          });

          if (course.diagnosis_id) fetchSymptoms(course.diagnosis_id);
        } else {
          setError("Patient course not found or no data available");
        }
      } catch (err) {
        setError(
          "Error fetching patient course data: " +
          (err.response?.data?.message || err.message)
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPatientCourse();
  }, [patient_course_id]);
const fetchMedicines = async () => {
  setLoadingMedicines(true);
  try {
    const res = await axios.get(
      "https://newerp.awasthivitality.com/api/products/list"
    );
    setMedicines(res.data?.data || []);
  } catch (err) {
    console.error("Failed to fetch medicines", err);
    setMedicines([]);
  } finally {
    setLoadingMedicines(false);
  }
};

useEffect(() => {
  fetchMedicines();
}, []);
const handleMedicineChange = (e) => {
  const { checked, value } = e.target;

  setSelectedMedicines((prev) =>
    checked ? [...prev, value] : prev.filter((m) => m !== value)
  );
};

  const fetchSymptoms = async (diagnosisId) => {
    if (!diagnosisId) return;
    setLoadingSymptoms(true);

    try {
      const res = await axios.get(
        `https://newerp.awasthivitality.com/api/diagnosis/${diagnosisId}/symptoms`
      );
      const fetchedSymptoms = res.data?.data?.symptoms || [];
      setSymptoms(fetchedSymptoms);
      console.log('Fetched symptoms:', fetchedSymptoms);
    } catch (err) {
      console.error("Failed to fetch symptoms", err);
      setSymptoms([]);
    } finally {
      setLoadingSymptoms(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSymptomChange = (e) => {
    const checked = e.target.checked;
    const value = parseInt(e.target.value);
    
    setFormData((prev) => {
      const prevSymptoms = Array.isArray(prev.symptom_names) ? prev.symptom_names : []; // Ensure it's an array
      const updated = checked
        ? [...prevSymptoms, value]
        : prevSymptoms.filter((s) => s !== value);
      
      console.log('Updated symptoms:', updated);
      return { ...prev, symptom_names: updated };
    });
  };
  // const sortedMedicineKeys = Object.keys(groupedMedicines).sort();

// Group medicines alphabetically by first letter
const groupedMedicines = medicines.reduce((acc, med) => {
  const firstLetter = med.product_name?.charAt(0).toUpperCase() || "#";

  if (!acc[firstLetter]) {
    acc[firstLetter] = [];
  }
  acc[firstLetter].push(med);

  return acc;
}, {});

const sortedMedicineKeys = Object.keys(groupedMedicines).sort();


  const handleDiagnosisChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selected = diagnosisOptions.find((d) => d.diagnosis_id === selectedId);
    if (!selected) return;

    setFormData((prev) => ({
      ...prev,
      diagnosis_id: selectedId,
      diagnosis: selected.name,
      diagnosisCode: selected.diagnosis_code,
      symptom_names: [], // Clear symptoms when diagnosis changes
    }));
    fetchSymptoms(selectedId);
  };

  // Fixed submit function - now sends data in request body
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      // Prepare the data to send
      const updateData = {
        diagnosis_id: formData.diagnosis_id || null,
        diagnosis_symptom_id: Array.isArray(formData.symptom_names) && formData.symptom_names.length > 0 
          ? formData.symptom_names[0] 
          : null,
        sign_symptom_all: Array.isArray(formData.symptom_names) && formData.symptom_names.length > 0 
          ? formData.symptom_names 
          : null,
        diagnosis_code: formData.diagnosisCode || null,
        medicine_names: selectedMedicines.join(", "), // Convert array back to "Med1, Med2"
        service_type: formData.regMode || null,
        remark: formData.remark || null,
        remark4: formData.remark4 || null,
          course_date: formData.course_date || null, // ✅ ADD

      };

      console.log('Sending update data:', updateData);
      console.log('Current form data:', formData);

      const res = await axios.put(
        `https://newerp.awasthivitality.com/api/patient-course/update/${patient_course_id}`,
        updateData,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

     if (res.data.status) {
  alert(res.data.message || "Patient updated successfully!");

  if (patientId) {
    navigate(`/patient/details/${patientId}`, { replace: true });
  } else {
    console.error("Patient ID not found for redirect");
  }
}

 else {
        alert("Update failed: " + (res.data.message || "Unknown error"));
      }
    } catch (err) {
      console.error("Update error:", err.response?.data || err.message);
      alert(
        "Failed to update patient: " +
        (err.response?.data?.message || err.message)
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <p>Loading patient data...</p>;
  if (error)
    return (
      <div style={{ color: "red", padding: "20px", border: "1px solid red" }}>
        <h3>Error</h3>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );

  return (
    <div className="emp-container">
<div className="emp-header">
  <h2>Edit Patient Diagnosis - ID: {patient_course_id}</h2>

  <div className="emp-date-box">
    <label>Visit Date</label>
    <input
      type="date"
      name="course_date"
      value={formData.course_date || ""}
      onChange={handleChange}
    />
  </div>
</div>
      <form onSubmit={handleSubmit}>
        <div className="emp-section">
          <h3>Diagnosis</h3>
          <div className="emp-form-row">
            <div>
              <label>Diagnosis</label>
              <select
                value={formData.diagnosis_id || ""}
                onChange={handleDiagnosisChange}
              >
                <option value="">Select Diagnosis</option>
                {diagnosisOptions.map((d) => (
                  <option key={d.diagnosis_id} value={d.diagnosis_id}>
                    {d.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>Diagnosis Code</label>
              <input
                type="text"
                name="diagnosisCode"
                value={formData.diagnosisCode || ""}
                onChange={handleChange}
              />
            </div>
            
            <div>
              <label>Dosing</label>
              <input
                type="text"
                name="remark"
                value={formData.remark || ""}
                onChange={handleChange}
              />
            </div>
            <div>
              <label>Visit Remark</label>
              <input
                type="text"
                name="remark4"
                value={formData.remark4 || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          
{/* ✅ Symptoms + Medicines side by side */}
<div className="emp-symptoms-medicine-row">

  {/* LEFT — Symptoms */}
  <div className="emp-half">
    <label>Symptoms</label>

    {loadingSymptoms ? (
      <p>Loading...</p>
    ) : (
      <div className="emp-symptoms-box">
        {symptoms.map((sym) => {
          const isChecked =
            formData.symptom_names.includes(sym.diagnosis_symptom_id);

          return (
            <label key={sym.diagnosis_symptom_id} className="emp-chip">
              <input
                type="checkbox"
                value={sym.diagnosis_symptom_id}
                checked={isChecked}
                onChange={handleSymptomChange}
              />
              <span>{sym.symptom}</span>
            </label>
          );
        })}
      </div>
    )}
  </div>

  {/* RIGHT — Medicines */}
{/* RIGHT — Medicines */}
<div className="emp-half">
  <label>Medicines</label>

  {loadingMedicines ? (
    <p>Loading medicines...</p>
  ) : (
    <div
      className="emp-symptoms-box"
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        border: "1px solid #ddd",
        padding: "10px"
      }}
    >
      {sortedMedicineKeys.map((letter) => (
        <div key={letter} style={{ marginBottom: "12px" }}>
          
          {/* Alphabet Row */}
          <div
            style={{
              fontWeight: "bold",
              background: "#f1f5f9",
              padding: "6px 10px",
              borderRadius: "6px",
              marginBottom: "6px"
            }}
          >
            {letter}
          </div>

          {/* Medicines under alphabet */}
          {groupedMedicines[letter].map((med) => {
            const isChecked = selectedMedicines.includes(med.product_name);

            return (
              <label key={med.product_id} className="emp-chip">
                <input
                  type="checkbox"
                  value={med.product_name}
                  checked={isChecked}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    setSelectedMedicines((prev) =>
                      checked
                        ? [...prev, value]
                        : prev.filter((m) => m !== value)
                    );
                  }}
                />
                <span>{med.product_name}</span>
              </label>
            );
          })}
        </div>
      ))}
    </div>
  )}
</div>


</div>

        </div>
        {/* <div className="form-row">
          <div>
            <label>Mode</label>
            <select
              name="regMode"
              value={formData.regMode || ""}
              onChange={handleChange}
            >
              <option value="">Select Mode</option>
              <option value="VISIT">VISIT</option>
              <option value="COURIER">COURIER</option>
              <option value="SOMEONE">SOMEONE</option>
            </select>
          </div>
        </div> */}
        <button type="submit" disabled={submitting} style={{ backgroundColor: '#0dcaf0' }}>
          {submitting ? "Updating..." : "Update Patient"}
        </button>
      </form>
      
      {/* Debug information */}
      {/* <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f0f0f0', fontSize: '12px' }}>
        <h4>Debug Info:</h4>
        <p>Current Diagnosis ID: {formData.diagnosis_id}</p>
        <p>Selected Symptoms: {JSON.stringify(formData.symptom_names)}</p>
        <p>Available Symptoms: {symptoms.length}</p>
        <p>Symptom Names Type: {typeof formData.symptom_names}</p>
        <p>Is Array: {Array.isArray(formData.symptom_names) ? 'Yes' : 'No'}</p>
      </div> */}
    </div>
  );
};

export default EditMorePatient;